import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import CardsSection from './components/CardsSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import MediaSection from './components/MediaSection';
import FaqSection from './components/FaqSection';
import FeaturesSection from './components/FeaturesSection';
import IndexSection from './components/IndexSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <ContactSection />
        <TopicsSection />
        <AboutSection />
        <UpdatesSection />
        <CarouselSection />
        <CommentsSection />
        <CardsSection />
        <AppSection />
        <RankingSection />
        <MediaSection />
        <FaqSection />
        <FeaturesSection />
        <IndexSection />
      </main>
      <Footer />
    </>
  );
}